module.exports = __webpack_public_path__ + "img/quote-2.fa48c187.webp";